/* eslint-disable id-blacklist */
import classNames from 'clsx';
import { format } from 'date-fns';
import React, { useState } from 'react';

import EventDetailsModal from './EventDetailsModal';
import styles from './Events.scss';

export interface Table {
  events: EventDetails[];
}

export interface EventDetails {
  title: string;
  type: string;
  dayId: string;
  orderId: string;
  gameType: string;
  startDate: Date;
  endDate: Date;
  registrationEndDate: Date;
  startingStack: string;
  status: string;
  buyin: string;
  sopUrl: string;
  sopDescription: string;
  entry: { cost: string; fee: string; dst: string };
  reEntry: { cost: string; fee: string; dst: string };
}

const EventDetailsTable: React.FC<Table> = ({ events }) => {
  const [selectedEvent, setSelectedEvent] = useState(-1);

  return (
    <div className={styles.tableContainer}>
      <table className={styles.eventsTable}>
        <thead>
          <tr>
            <th>Time</th>
            <th className={styles.optionalData}>Event Number</th>
            <th>Event</th>
            <th className={styles.optionalData}>Buy-In</th>
            <th className={styles.optionalData}>Starting Stack</th>
            <th className={styles.optionalData}>Registration Closes At</th>
          </tr>
        </thead>
        <tbody>
          {events.map((item, i) => {
            let formattedPrevStartDate = '';
            if (i) {
              formattedPrevStartDate = format(new Date(events[i - 1].startDate), 'MMMM dd - EEEE');
            }

            const formattedStartDate = format(new Date(item.startDate), 'MMMM dd - EEEE');
            const formattedEndDate =
              item.registrationEndDate.getTime() < new Date().getTime()
                ? 'Registration closed'
                : format(item.registrationEndDate, 'dd.MM.yyyy');

            return (
              <React.Fragment key={i}>
                {formattedPrevStartDate !== formattedStartDate && (
                  <tr>
                    <td className={styles.tableSubHeader} colSpan={8}>
                      {formattedStartDate}
                    </td>
                  </tr>
                )}
                <tr>
                  <td>{format(new Date(item.startDate), 'HH:mm')}</td>
                  <td className={styles.optionalData}>{`${item.orderId} ${item.dayId}`}</td>
                  <td>
                    <span className={styles.eventTitle} onClick={() => setSelectedEvent(i)}>
                      {item.title}
                    </span>
                    <div className={styles.optionalColumnData}>
                      <strong>Event Number </strong> {`${item.orderId} ${item.dayId}`}
                      <br />
                      <strong>Buy-In </strong> {item.buyin}
                      <br />
                      <strong>Starting stack </strong> {item.startingStack}
                      <br />
                      <strong>Registration closes at </strong>
                      {formattedEndDate}
                    </div>
                    {i === selectedEvent && (
                      <EventDetailsModal {...item} onClose={() => setSelectedEvent(-1)} />
                    )}
                  </td>
                  <td className={styles.optionalData}>{item.buyin}</td>
                  <td className={classNames(styles.centerAlign, styles.optionalData)}>
                    {item.startingStack}
                  </td>
                  <td className={styles.optionalData}>{formattedEndDate}</td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default EventDetailsTable;
